import React, { useState, useEffect, useContext, useMemo } from 'react'
import { Location, useLocation } from '@reach/router'
import { navigate, graphql, useStaticQuery } from 'gatsby'

import Select from 'react-select'
import VersionContext from '../../contexts/versionContext'

import { changeUrlVersion, getVersionFromUrl } from '../../utils/navigation'
import style from './style'
import styles from './styles.module.css'

const ignorePaths = ['/start', '/changelog', '/tutorials']
const versionsStartWithV = (path, version) => path.startsWith('/v') && version.startsWith('v')
const versionsStartWithDigit = (path, version) => /^\/\d/.test(path) && /^\d/.test(version)

const VersionSwapper = () => {
  const { allMarkdownRemark } = useStaticQuery(query)
  const { version, setVersion } = useContext(VersionContext)
  const { pathname } = useLocation()

  const pathsWithAVersion = useMemo(
    () => ({
      version: ['2.0.0'],
      paths: ['update-subscription-charge-date'],
    }),
    []
  )

  const versions = allMarkdownRemark.distinct
    .filter(path => !ignorePaths.includes(path) && (versionsStartWithV(path, version) || versionsStartWithDigit(path, version)))
    .map(ver => ver.slice(1))
    .reverse()

  const [options, setOptions] = useState([])

  const getOptions = () => {
    pathname.includes(pathsWithAVersion.paths)
      ? setOptions(
          pathsWithAVersion.version.map(ver => ({
            value: ver,
            label: ver,
          }))
        )
      : setOptions(
          versions.map(ver => ({
            value: ver,
            label: ver,
          }))
        )
  }

  const handleClick = (newVersion, location) => {
    setVersion(newVersion)
    const currentVersion = getVersionFromUrl(location.pathname, versions)
    const newPath = changeUrlVersion(location.pathname, currentVersion, newVersion)
    const url = process.env.GATSBY_PATH_PREFIX ? newPath.replace(`/${process.env.GATSBY_PATH_PREFIX}`, '') : newPath

    navigate(url)
  }

  useEffect(() => getOptions(), [version]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Location>
      {({ location }) => (
        <div className={styles.container}>
          <Select
            components={{
              IndicatorSeparator: () => null,
            }}
            data-testid="sample-code-select"
            isSearchable={false}
            onChange={({ value }) => handleClick(value, location)}
            options={options}
            styles={style}
            value={{ label: version, value: version }}
          />
        </div>
      )}
    </Location>
  )
}

const query = graphql`
  {
    allMarkdownRemark {
      distinct(field: fields___verKey)
    }
  }
`
export default VersionSwapper
